import { useCallback, useEffect } from "react";
import useChangePassword from "@/domains/playerMenu/hooks/useChangePassword";
import useGameSettings from "@/domains/settings/hooks/useGameSettings";
import PlayerMenuSettingsSafetyChangePasswordNew from "@/domains/playerMenu/components/settings/safety/changePassword/PlayerMenuSettingsSafetyChangePasswordNew";

type Props = {
  onClose: () => void;
};

export default function PlayerMenuSettingsSafetyChangePasswordNewContainer({ onClose }: Props) {
  const { setNewPasswordHandler, newPasswordIsPending, newPasswordError, newPasswordIsCompleted } =
    useChangePassword();
  const { getGameSettings } = useGameSettings();

  const onSubmit = useCallback(({ password }) => {
    setNewPasswordHandler(password);
  }, []);

  useEffect(() => {
    if (newPasswordIsCompleted && !newPasswordError) {
      onClose();
      getGameSettings();
    }
  }, [newPasswordError, newPasswordIsCompleted]);

  return (
    <PlayerMenuSettingsSafetyChangePasswordNew
      onSubmit={onSubmit}
      pending={newPasswordIsPending}
      error={newPasswordError}
    />
  );
}
